import React from "react";

const BS5_Modal = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Modal Component</h2>
      <p>This is the BS5_Modal component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Modal;
